import { SELECT_POST_CALL_SURVEY } from './typeConstants';

export const selectPostCallSurvey = (data) => ({
    type: SELECT_POST_CALL_SURVEY,
    data,
});